import React, { useState } from 'react';
import PropTypes from 'prop-types'
import classnames from 'classnames'
import {FaChevronDown, FaChevronUp} from 'react-icons/fa'

let SearchSection = ({title, rows}, context) => {
  const [showAll, setShowAll] = useState(false)
  const showToggle = rows.length > 3

  function toggleMore() {
    setShowAll(!showAll)
  }

  if(rows.length == 0) {
    return null
  }
  else {
    const more_count = rows.length - 3
    const sectionClasses = classnames(
      {
        search_section: true,
        show_three: !showAll
      }
    )

    return (
      <div className={sectionClasses}>
      <h5>{ title }</h5>
      <ul className="image_list">{rows}</ul>
      {showToggle && ! showAll &&
        <div className="show_more"><button className="button small light with_icon browse_all" onClick={toggleMore}>Show {more_count} more <FaChevronDown /></button></div>
      }
      {showToggle && showAll &&
        <div className="show_more"><button className="button small light with_icon browse_all" onClick={toggleMore}>Show fewer <FaChevronUp /></button></div>
      }
      </div>
    )
    }
}

SearchSection.propTypes = {
  title: PropTypes.string,
  rows: PropTypes.array
}


export default SearchSection